// function to truncate text by words
export function truncateTextByWords(text, wordLimit = 10) {
  const words = text.split(/\s+/);
  return words.length > wordLimit
    ? words.slice(0, wordLimit).join(' ') + '...'
    : text;
}

// function to truncate text by characters
export function truncateTextByChars(text, charLimit = 50) {
  return text.length > charLimit
    ? text.slice(0, charLimit) + '...'
    : text;
}
// function to check for json Format
export function testJSON(str) {
  const jsonRegex = /^[\],:{}\s]*$/
    .test(str.replace(/\\["\\\/bfnrtu]/g, '@')
      .replace(/"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g, ']')
      .replace(/(?:^|:|,)(?:\s*\[)+/g, ''));
  return jsonRegex;
}

// function to validate number input values
export function validateInput(input, minValue = 0, maxValue = 10) {
  let value = Number(input.value); // Convert to number
  if (value < minValue) {
    input.value = minValue;
  } else if (value > maxValue) {
    input.value = maxValue;
  }
}

// dividing array based on limit



export function chunkArray(array, limit) {
  let result = [];
  for (let i = 0; i < array.length; i += limit) {
    result.push(array.slice(i, i + limit));
  }
  return result;
}
